import { Injectable } from '@angular/core';
import { Statique } from '../utils/statique';
import { Http, Response } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { SearchCriteria } from '../utils/searchCriteria';
import { EbEtablissement } from '../classes/etablissement';
import { EbCompagnie } from '../classes/compagnie';
import { EbUser } from '../classes/user';
import { EbLien } from '../classes/lien';

@Injectable()
export class CompagnieService {
  statique = Statique
  constructor(private authHttp:AuthHttp) { }

  getListEtablisementCompagnie(searchCriteria: SearchCriteria) {
    return this.authHttp.post(Statique.controllerCompagnie + "/get-list-etablissement-compagnie", searchCriteria)
    .map((res: Response) => res.json());
  }

  getListAgences() {
    return this.authHttp.get(Statique.controllerCompagnie + "/get-list-agences")
    .map((res: Response) => res.json());
  }
  
  addCompagnie(ebCompagnie:EbCompagnie){
    return this.authHttp.post(Statique.controllerCompagnie +  "/save", ebCompagnie)
      .map((res: Response) => res.json());
  }
  addCompagnieWithUser(user:EbUser){
    return this.authHttp.post(Statique.controllerCompagnie +  "/saveWithUser", user)
      .map((res: Response) => res.json());
  }

  getCompagnie(searchCriteria: SearchCriteria) {
    return this.authHttp.post(Statique.controllerCompagnie +  "/get-compagnie", searchCriteria)
      .map((res: Response) => res.json());
  }

  getListCompagnie(searchCriteria: SearchCriteria) {
    return this.authHttp.post(Statique.controllerCompagnie +  "/get-list-compagnie", searchCriteria)
      .map((res: Response) => res.json());
  }

  getListCompagnieWithPagination(searchCriteria: SearchCriteria, pageNumber : number, pageSize : number) {
    return this.authHttp.post(Statique.controllerCompagnie +  "/get-list-compagnie/datatable", searchCriteria)
      .map((res: Response) => res.json());
  }

  addEtablissementCompagnie(ebEtablissement: EbEtablissement){
    return this.authHttp.post(Statique.controllerEtablissement + "/add-etablissement", ebEtablissement)
    .map((res: Response) => res.json());
  }

  editEtablissementCompagnie(ebEtablissement : EbEtablissement){
    return this.authHttp.post(Statique.controllerCompagnie + "/update-etablissement-compagnie", ebEtablissement)
    .map((res: Response) => res.json());
  }

  addLienCompagnie(ebLien: EbLien){
    return this.authHttp.post(Statique.controllerCompagnie + "/add-lien-compagnie", ebLien)
    .map((res: Response) => res.json());
  }

  getListLienCompagnie(ebCompagnieNum: number){
    return this.authHttp.post(Statique.controllerCompagnie + "/get-list-lien-compagnie", ebCompagnieNum)
    .map((res: Response) => res.json());
  }

  editLienCompagnie(ebLien: EbLien){
    return this.authHttp.post(Statique.controllerCompagnie + "/update-lien-compagnie", ebLien)
    .map((res: Response) => res.json());
  }

  deleteLienCompagnie(id: number){
    return this.authHttp.post(Statique.controllerCompagnie + "/delete-lien-compagnie", id )
    .map((res: Response) => res.json());
  }

  getListAddressCompagnie(ebCompagnieNum : number){
    return this.authHttp.post(Statique.controllerCompagnie + "/get-address-compagnie", ebCompagnieNum)
    .map((res: Response) => res.json());
  }

  getListAgenceCompagnie(agenceType : String, ebCompagnieNum : number){
    return this.authHttp.post(Statique.controllerCompagnie + "/get-list-agence-compagnie/"+ebCompagnieNum, agenceType)
    .map((res: Response) => res.json());
  }

  getCompaniePrestataire(role : number){
    return this.authHttp.post(Statique.controllerCompagnie + "/get-compagnie-prestataire", role)
    .map((res: Response) => res.json());
  }

  getSelectedChargeurCompagnie(ebDemandeNum: number){
    return this.authHttp.get(Statique.controllerCompagnie + "/get-selectedChargeur-compagnie/"+ebDemandeNum)
    .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/compagnie.service.ts